import { IResponse } from '@/types/interfaces';
// eslint-disable-next-line import/no-cycle
import ApiService from '@/services/ApiService';

export default class JourneyService {
  public static registerJourney(): Promise<IResponse<null>> {
    return ApiService.getAndReturnData('/ping');
  }
}
